<template>
  <div class="container" @click="close_detail">
    <div class="page">
      <div class="top-title">Style Information and Specification Selection</div>
      <template v-if="from === 'draft'">
        <div class="cate-no-box">
          <div class="custom-no">
            <div class="label">Custom Style Number</div>
            <input
              type="text"
              class="input"
              v-model="new_style_no"
              placeholder="Please enter your custom style number, leave blank to be auto-generated by system"
            />
          </div>
          <div class="other-items">
            <div class="label">Style Name</div>
            <div class="input">{{ design.name }}</div>
          </div>
          <div class="other-items">
            <div class="label">Style Category</div>
            <div class="input">{{ design.product_category_name }}</div>
          </div>
        </div>
      </template>

      <!-- <h3 class="title">尺码选择<span class="btn-add cursor" @click="open_choose_size_popup">+ 添加尺码</span></h3> -->
      <div class="label-title">
        Size Selection({{ select_size_ids.length }})
      </div>
      <div class="spec-list" style="font-size: 16px">
        <div class="item-box">
          <div class="spec-item" v-for="(v, k) in select_size_ids" :key="k">
            {{ v }}
            <img
              src="@/assets/images/design/icon-del.png"
              alt=""
              class="icon-del cursor"
              @click.stop="remove_selected_size(v)"
            />
          </div>
        </div>
        <div class="add-btn" @click="open_choose_size_popup">Add Size</div>
      </div>
      <!-- <h3 class="title">颜色选择<span class="btn-add cursor" @click="open_choose_color_popup">+ 添加颜色</span></h3> -->
      <div class="label-title">
        Color Selection({{ available_color_list.length }})
      </div>
      <div class="spec-list" style="font-size: 16px">
        <div class="item-box">
          <div
            class="spec-item"
            v-for="(v, k) in available_color_list"
            :key="k"
          >
            <img :src="v.color_value | default_img" alt="" />
            <span>{{ v.color_name_en }}</span>
            <img
              src="@/assets/images/design/icon-del.png"
              alt=""
              class="icon-del cursor"
              @click.stop="remove_selected_color(v.color_id)"
            />
          </div>
        </div>
        <div class="add-btn" @click="open_choose_color_popup">Add Color</div>
      </div>
      <!-- <h3 class="title">已选择 <span class="tip">(尺码规格名称可根据需求进行自定义修改)</span></h3> -->
      <div class="label-title">Selected Specifications/Colors</div>
      <table class="table">
        <tr>
          <th class="size">Size</th>
          <th
            class="color"
            v-for="(v, k) in available_color_list"
            :key="`color` + k"
          >
            <img
              src="@/assets/images/icon-edit-pink.png"
              alt=""
              class="icon-edit cursor"
              @click="open_modify_color_popup(v.color_id)"
            />
            {{ v.color_name }}(pcs)
          </th>
          <th
            class="complete"
            v-for="(v, k) in complete_list"
            :key="`complete` + k"
          >
            {{ v.field_name_en }}(cm)
          </th>
        </tr>
        <template v-for="(v, k) in table_data">
          <tr>
            <td>
              <img
                src="@/assets/images/icon-edit-pink.png"
                alt=""
                class="icon-edit cursor"
                @click="open_modify_size_popup(v.size.size_key)"
              />
              {{ v.size.size_alias }}
            </td>
            <td class="color" v-for="(vv, kk) in v.color" :key="`color` + kk">
              <input class="input" type="text" v-model="vv.quantity" />
            </td>
            <td
              class="complete"
              v-for="(vv, kk) in v.complete"
              :key="`complete` + kk"
            >
              <input
                class="input"
                type="text"
                v-model="vv.val"
                @blur="blur($event, vv)"
              />
            </td>
          </tr>
        </template>
      </table>
    </div>
    <div class="page">
      <div class="big-title">Style Details</div>
      <div class="report" style="overflow: hidden">
        <div class="wrap">
          <div class="left">
            <div class="kuanshitu cell">
              <h3 class="title">Style Images:</h3>
              <div class="image-list">
                <template v-for="(v, k) in design.image_list">
                  <img
                    v-if="util.test_image(v)"
                    :src="v"
                    :key="k"
                    alt=""
                    class="image-item"
                    v-viewer
                  />
                  <img
                    v-if="typeof v === 'object' && util.test_image(v.raw)"
                    :src="v.raw"
                    :key="k"
                    alt=""
                    class="image-item"
                    v-viewer
                  />
                </template>
              </div>
              <template v-for="(v, k) in design.image_list">
                <a
                  v-if="typeof v === 'object' && !util.test_image(v.raw)"
                  target="_blank"
                  :href="v.raw"
                  >{{ v.raw_name }}</a
                >
              </template>
              <div class="kuanshishuoming">
                <h3 class="title">Style Description:</h3>
                <p style="margin: 20px 10px">{{ design.description }}</p>
              </div>
            </div>
            <div class="banxing cell">
              <h3 class="title">Pattern Files:</h3>
              <p>Type:{{ design.pattern_type | get_pattern_type }}</p>
              <template v-for="(v, k) in design.pattern">
                <template v-if="design.pattern_type === 1">
                  <a class="file-item" :href="v.path" target="_blank">
                    {{ v.name }}
                  </a>
                </template>
                <template v-if="design.pattern_type === 2">
                  <a class="file-item" :href="v.path" target="_blank">
                    {{ v.name }}
                  </a>
                </template>
                <template v-if="design.pattern_type === 3">
                  <p>Scenario:{{ v.c_scene }}</p>
                  <p>Description: {{ v.c_type }}</p>
                  <p>Introduction:{{ v.c_content }}</p>
                </template>
              </template>
            </div>
            <div class="mianliao-cell cell">
              <h3 class="title">Fabric/Lining Details:</h3>
              <div class="table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Product Information</th>
                      <th>Color</th>
                      <th>Composition</th>
                      <th>Width/Weight</th>
                      <th>Note</th>
                      <th>Send Sample</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in design.material" :key="`m` + k">
                      <td>{{ v.alias }}</td>
                      <td>
                        <div class="table-info">
                          <img
                            v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer
                          />
                          <div class="text">
                            <span class="fa-name">{{ v.fabric_name_en }}</span>
                            <span class="fa-key">{{ v.fabric_key }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="colors">
                          <img
                            class="color-image"
                            v-if="v.color_value"
                            :src="v.color_value"
                            v-viewer
                          />
                          <div class="color-name">{{ v.color_name_en }}</div>
                        </div>
                      </td>
                      <td>{{ v.component_en }}</td>
                      <td>{{ v.width_wide }}</td>
                      <td>{{ v.desc }}</td>
                      <td>
                        <div class="sample">
                          <input
                            tool-tip="Uncheckable means sample sending is not supported"
                            :disabled="
                              !(
                                form_data_sample[v.id] &&
                                form_data_sample[v.id].is_support_send_sample >
                                  0
                              )
                            "
                            v-model="form_data_sample[v.id].need_sample"
                            type="checkbox"
                          />
                        </div>
                      </td>
                    </tr>
                    <template v-if="design.is_material_self">
                      <tr
                        v-for="(item, index) in design.material_self"
                        :key="'ms' + index"
                      >
                        <td>
                          <div>
                            <p style="color: red">Custom</p>
                            <p>{{ item.alias }}</p>
                          </div>
                        </td>
                        <td>
                          <div class="table-info">
                            <img
                              v-if="!!item.image"
                              :src="item.image"
                              alt=""
                              class="fa-img"
                              v-viewer
                            />
                            <div class="text">
                              <span class="fa-name">
                                {{ item.fabric_name_cn }}
                              </span>
                              <span class="fa-key">{{ item.fabric_key }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="colors">
                            <img
                              class="color-image"
                              v-if="item.color_value"
                              :src="item.color_value"
                              v-viewer
                            />
                            <div class="color-name">
                              {{ item.color_name_en }}
                            </div>
                          </div>
                        </td>
                        <td>{{ item.component }}</td>
                        <td>{{ item.width_wide }}</td>
                        <td>{{ item.desc }}</td>
                        <td>
                          <div class="sample">No</div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="fuliao-cell cell">
              <h3 class="title">Accessories Details:</h3>
              <div class="table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Specification</th>
                      <th>Color</th>
                      <th>Specification</th>
                      <th>Usage Quantity</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in design.accessory" :key="`m` + k">
                      <td></td>
                      <td>
                        <div class="product-info">
                          <img
                            v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer
                          />
                          <div class="text">
                            <span class="fa-name">{{
                              v.accessory_name_en
                            }}</span>
                            <span class="fa-key">{{ v.accessory_sku }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="fuliao-colors">
                          <img
                            class="fuliao-color"
                            v-if="v.color_value"
                            :src="v.color_value"
                            v-viewer
                          />
                          <div class="fuliao-color-name">
                            {{ v.color_name_en }}
                          </div>
                        </div>
                      </td>
                      <td>{{ v.measure_unit_en || "" }}</td>
                      <td>{{ v.num }}</td>
                      <td>{{ v.desc }}</td>
                    </tr>
                    <template v-if="design.is_accessory_self">
                      <tr
                        v-for="(v, k) in design.accessory_self"
                        :key="`as` + k"
                      >
                        <td>
                          <span style="color: red">Custom</span>
                        </td>
                        <td>
                          <div class="product-info">
                            <img
                              v-if="!!v.image"
                              :src="v.image"
                              alt=""
                              class="fa-img"
                              v-viewer
                            />
                            <div class="text">
                              <span class="fa-name">
                                {{ v.accessory_name }}
                              </span>
                              <span class="fa-key">{{ v.accessory_sku }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fuliao-colors">
                            <img
                              class="fuliao-color"
                              v-if="v.color_value"
                              :src="v.color_value"
                              v-viewer
                            />
                            <div class="fuliao-color-name">
                              {{ v.color_name_en }}
                            </div>
                          </div>
                        </td>
                        <td>{{ v.measure_unit_en || "" }}</td>
                        <td>{{ v.num }}</td>
                        <td>{{ v.desc }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="cell border-top other-file-cell">
                      <h3 class="title">其他附件：</h3>
                      <div class="file-list">
                          <a
                                  target="_blank"
                                  :href="v.path"
                                  class="file-item"
                                  v-for="(v, k) in design.other_file"
                                  :key="`of` + k"
                          >
                              {{ v.name }}
                          </a>
                      </div>
                  </div>
                  <div class="cell border-bottom-no">
                      <h3 class="title">其他要求和备注说明：</h3>
                      {{ design.other_remark }}
                  </div> -->
      </div>
    </div>

    <!-- 增加尺码弹窗 -->
    <popup
      :show.sync="is_choose_size_popup_show"
      height="300px"
      width="960px"
      @on-close="close_choose_size_popup"
    >
      <div class="popup">
        <div class="title">Size Selection</div>
        <template v-if="[0,2,3].includes(design.pattern_type)">
          <select class="group-list" v-model="current_group_id" @change="change_group">
            <option v-for="(v,k) in raw_group_list" :value="v.id"> {{v.name_en || v.name}}</option>
          </select>
        </template>

        <div class="color-list size-list">
          <div
            class="color-item cursor"
            :class="{ active: temp_size_ids.includes(v) }"
            v-for="(v, k) in raw_size_list"
            @click="toggle_size(v)"
          >
            <span>{{ v }}</span>
          </div>
        </div>
        <div class="btn-modify cursor" @click="confirm_choose_size_popup">
          Confirm
        </div>
      </div>
    </popup>
    <!-- 修改尺码名称弹窗 -->
    <popup
      :show.sync="is_modify_size_show"
      height="250px"
      width="520px"
      @on-close="close_modify_size_popup"
    >
      <div class="popup">
        <div class="title">Size Name</div>
        <div class="form-group">
          <div class="label">Custom Name</div>
          <input class="input" v-model="form_data_custom_size.size_alias" />
        </div>
        <div class="tip">
          <span>Warm Tip:</span>
          Custom name information will be displayed on labels, washing tags,
          collar tags and other materials. If not filled in, the size name will
          be displayed.
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_size">
          Confirm Modification
        </div>
      </div>
    </popup>

    <!-- 增加颜色弹窗 -->
    <popup
      :show.sync="is_choose_color_popup_show"
      height="700px"
      width="960px"
      @on-close="close_choose_color_popup"
    >
      <div class="popup">
        <div class="title">Fabric Color Selection</div>
        <div class="color-list">
          <div
            class="color-item cursor"
            :class="{ active: temp_color_ids.includes(v.color_id) }"
            v-for="(v, k) in raw_color_list"
            @click="toggle_color(v.color_id)"
          >
            <img :src="v.color_value | default_img" alt="" />
            <span>{{ v.color_name_en }}</span>
          </div>
          <div
            class="color-item cursor"
            :class="{ active: temp_color_ids.includes(v.color_id) }"
            v-for="(v, k) in custom_color"
            @click="toggle_color(v.color_id)"
          >
            <span>{{ v.color_name }}</span>
            <img
              v-if="custom_color.map((v) => v.color_id).includes(v.color_id)"
              src="@/assets/images/design/icon-del.png"
              alt=""
              class="icon-del cursor"
              @click.stop="del_custom_color(v.color_id)"
            />
          </div>
        </div>
        <div class="btn-modify cursor" @click="confirm_choose_color_popup">
          Confirm
        </div>

        <div class="form-group">
          <div class="label">Custom Add Color</div>
          <input class="input" v-model="form_data_custom_color.color_alias" />
          <div class="btn-add cursor" @click="add_custom_color">
            Click to Add
          </div>
        </div>
        <div class="tip">
          <span>Warm Tip:</span>
          Custom name information will be displayed on labels, washing tags,
          collar tags and other materials. If not filled in, the size name will
          be displayed.
        </div>
      </div>
    </popup>

    <!-- 修改尺码名称弹窗 -->
    <popup
      :show.sync="is_modify_color_show"
      height="250px"
      width="520px"
      @on-close="close_modify_color_popup"
    >
      <div class="popup">
        <div class="title">Color Name</div>
        <div class="form-group">
          <div class="label">Custom Name</div>
          <input class="input" v-model="form_data_modify_color.color_name" />
        </div>
        <div class="tip">
          <span>Warm Tip:</span>
          Custom name information will be displayed on labels, washing tags,
          collar tags and other materials. If not filled in, the size name will
          be displayed.
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_color">
          Confirm Modification
        </div>
      </div>
    </popup>

    <div class="footer">
      <div class="footer-wrapper">
        <div class="price-btns">
          <div
            class="btn btn-back"
            @click="$router.go(-1)"
            v-if="$route.query.from === 'draft'"
          >
            Return to Edit
          </div>
          <div class="price-wrap">
            Quantity: ×{{ count }}
            <span class="shu">|</span>
            Total Cost:
            <span class="money2">$ {{ total_price | price_format }}</span>
            USD
            <span class="btn-detail" @click.stop="show_detail"
              >View Details &gt;</span
            >
            <div class="detail-modal" v-show="is_detail_show">
              <div class="p-list">
                <div
                  class="p-item"
                  v-for="(v, k) in design.cost_list"
                  :key="`dc` + k"
                >
                  <div class="left">{{ v.title }}</div>
                  <div class="right">
                    ${{
                      (v.is_single ? v.amount : v.amount * count) | price_format
                    }}
                  </div>
                </div>
                <div class="p-item">
                  <div class="left">Sample Fee</div>
                  <div class="right">${{ sample_price | price_format }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn btn-confirm" @click="submit">
            Submit for Sample Production
          </div>
        </div>
        <div class="footer-tips">
          Note: This fee only covers the basic production cost for the style.
          Additional charges will apply for services such as printing,
          embroidery, or special techniques, subject to confirmation by customer
          service. Please be advised accordingly!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CreateOrder, GetDesign, GetDraft, Profile } from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import util from "@/utils/util";
import axios from "axios";

export default {
  name: "Summary",
  components: {
    Popup,
  },
  filters: {
    get_pattern_type(v) {
      if (v === 1) {
        return "Platform Pattern";
      } else if (v === 2) {
        return "Customer-provided Pattern";
      } else if (v === 3) {
        return "Custom Pattern";
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      util: util,
      is_detail_show: false,
      is_click: false,
      design: {
        tech: {},
        cost_list: [],
        material: [],
      },
      // 约等于要提交的表单数据
      table_data: {
        // {size: {size_key:'', size_alias: ''},color: {}, complete: {}}
      },
      // 成衣部位数据
      complete_list: [],
      current_group_id: 0,
      // 可选尺码分组
      raw_group_list: [{
        name: 'Please Select',
        id: 0,
        size_list: []
      }],
      // 所有尺码数据
      raw_size_list: [],
      // 已选尺码KEY
      temp_size_ids: [],
      select_size_ids: [],
      // 主面料A的颜色数据
      raw_color_list: [
        {
          color_id: -1,
          color_key: -1,
          color_name: "Default Color",
          color_name_en: "Default Color",
          color_value: "",
        },
      ],
      // 自定义颜色数据
      custom_color: [],
      temp_color_ids: [],
      // 已选颜色ID
      select_color_ids: [],
      // 是否寄样数据
      form_data_sample: {},
      // 页面来源，草稿提交和款式再次下单
      from: "",
      // 仅来自草稿提交时有效
      new_style_no: "",
      is_choose_size_popup_show: false,
      is_modify_size_show: false,
      form_data_custom_size: {
        size_key: "",
        size_alias: "",
      },
      is_choose_color_popup_show: false,
      form_data_custom_color: {
        id: 0,
        color_alias: "",
      },
      is_modify_color_show: false,
      form_data_modify_color: {
        color_id: 0,
        color_name: "",
      },
    };
  },
  computed: {
    material_map() {
      let obj = {};
      for (let i in this.design.material) {
        obj[this.design.material[i].id] = this.design.material[i];
      }
      return obj;
    },
    sample_price() {
      let price = 0;
      for (let i in this.form_data_sample) {
        if (this.form_data_sample[i].need_sample > 0) {
          price += parseFloat(this.form_data_sample[i].sample_price);
        }
      }
      return price;
    },
    total_price() {
      let once_price = this.design.cost_list
        .filter((v) => v.is_single)
        .map((v) => v.amount)
        .reduce((a, b) => a + b, 0);
      return (
        this.design.factory_price * this.count +
        parseFloat(once_price) +
        parseFloat(this.sample_price)
      );
    },
    count() {
      let res = 0;
      for (let i in this.table_data) {
        for (let j in this.table_data[i].color) {
          res += parseInt(this.table_data[i].color[j].quantity || 0);
        }
      }

      return res;
    },
    available_color_list() {
      let arr = this.raw_color_list.filter((v) =>
        this.select_color_ids.includes(v.color_id)
      );
      for (let i in this.custom_color.filter((v) =>
        this.select_color_ids.includes(v.color_id)
      )) {
        arr.push(this.custom_color[i]);
      }

      return arr;
    },
  },
  async mounted() {
    this.from = this.$route.query.from;
    if (this.$route.query.uuid) {
      let response =
        this.from === "design"
          ? await GetDesign({ uuid: this.$route.query.uuid })
          : await GetDraft({ uuid: this.$route.query.uuid });
      this.design = response.data;
      let obj = this.design.material.find((v) => v.alias === "Fabric A");
      if (obj && obj.color_list.length > 0) {
        this.raw_color_list = this.$_.cloneDeep(obj.color_list);
        if (obj.color_key) {
          let c = this.raw_color_list.find((v) => v.color_key == obj.color_key);
          if (c) {
            this.choose_color(c.color_id);
          } else {
            this.choose_color(this.raw_color_list[0].color_id);
          }
        } else {
          this.choose_color(this.raw_color_list[0].color_id);
        }
      } else {
        this.choose_color(this.raw_color_list[0].color_id);
      }
      if (this.design.pattern_type === 1) {
        this.raw_size_list = this.design?.pat?.size_list || [];
        this.complete_list = this.design?.pat?.field_list || [];
        // 处理默认选择的尺码
        let s = this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
        this.choose_size(s);
      } else if (this.design.pattern_type === 2) {
        // 自供版型情况
        if(this.design.pattern[0].sex == '男') {
          let g = this.design.productcategory.size_group_list.find(v=>v.key === '男')
          this.raw_group_list = g ? [...this.raw_group_list, ...g.group] : undefined;
        }
        if(this.design.pattern[0].sex == '女') {
          let g = this.design.productcategory.size_group_list.find(v=>v.key === '女')
          this.raw_group_list = g ? [...this.raw_group_list, ...g.group] : undefined;
        }
        if (this.design.pattern[0].sex == "儿童") {
          this.raw_size_list = this.design.productcategory.size_list_child;
        }
        if (this.design.pattern[0].sex == "不限") {
          this.raw_size_list = []
          for(let i in this.design.productcategory.size_group_list) {
            this.raw_group_list = [...this.raw_group_list, ...(this.design.productcategory.size_group_list[i].group)]
          }
        }
      } else if (this.design.pattern_type === 3) {
        // 定制版型情况
        this.complete_list = this.design.productcategory.field_list;
        if(this.design.pattern[0].sex == '男') {
          let g = this.design.productcategory.size_group_list.find(v=>v.key === '男')
          this.raw_group_list = g ? [...this.raw_group_list, ...g.group] : undefined;
        }
        if(this.design.pattern[0].sex == '女') {
          let g = this.design.productcategory.size_group_list.find(v=>v.key === '女')
          this.raw_group_list = g ? [...this.raw_group_list, ...g.group] : undefined;
        }
        if (this.design.pattern[0].sex == "儿童") {
          let g = this.design.productcategory.size_group_list.find(v=>v.key === '童')
          this.raw_group_list = g ? [...this.raw_group_list, ...g.group] : undefined;
        }
        if (this.design.pattern[0].sex == "不限") {
          this.raw_size_list = []
          for(let i in this.design.productcategory.size_group_list) {
            this.raw_group_list = [...this.raw_group_list, ...(this.design.productcategory.size_group_list[i].group)]
          }
        }
      } else {
        this.raw_size_list = []
        for(let i in this.design.productcategory.size_group_list) {
          this.raw_group_list = [...this.raw_group_list, ...(this.design.productcategory.size_group_list[i].group)]
        }
      }

      // 记录面料是否选择寄样服务
      for (let i in this.design.material) {
        this.$set(this.form_data_sample, this.design.material[i].id, {
          is_support_send_sample:
            this.design.material[i].is_support_send_sample,
          need_sample: 0,
          sample_price: this.design.material[i].sample_price,
        });
      }
    }
    axios.all([this.getProfile()]);
  },
  methods: {
    change_group($event) {
      let g = this.raw_group_list.find(v=>v.id===this.current_group_id)
      this.raw_size_list = g ? g.size_list : []
    },
    blur($e, v) {
      let temp = $e.target.value;
      if (isNaN(temp)) {
        v.val = v.normal;
      }
      temp = parseFloat(temp);
      if (temp < parseFloat(v.normal) + parseFloat(v.min)) {
        v.val = parseFloat(v.normal) + parseFloat(v.min);
      }
      if (temp > parseFloat(v.normal) + parseFloat(v.max)) {
        v.val = parseFloat(v.normal) + parseFloat(v.max);
      }
      v.val = Math.round(v.val * 10) / 10;
    },
    toggle_color(color_id) {
      if (this.temp_color_ids.includes(color_id)) {
        this.temp_color_ids = this.temp_color_ids.filter((item) => {
          return item !== color_id;
        });
      } else {
        this.temp_color_ids.push(color_id);
        this.temp_color_ids = [...new Set(this.temp_color_ids)];
      }
    },
    confirm_choose_color_popup() {
      this.temp_color_ids.forEach((v) => {
        if (!this.select_color_ids.includes(v)) {
          this.choose_color(v);
        }
      });
      this.temp_color_ids = [];
      this.is_choose_color_popup_show = false;
    },
    choose_color(color_id) {
      if (this.select_color_ids.includes(color_id)) {
        this.select_color_ids = this.select_color_ids.filter((item) => {
          return item !== color_id;
        });
      } else {
        this.select_color_ids.push(color_id);
        this.select_color_ids = [...new Set(this.select_color_ids)];
      }
      for (let i in this.table_data) {
        let obj = this.table_data[i];

        if (this.$_.has(obj.color, color_id)) {
          delete obj.color[color_id];
        } else {
          let color = this.available_color_list.find(
            (v) => v.color_id === color_id
          );
          obj.color[color_id] = { ...color, quantity: 0 };
        }
        this.$set(this.table_data, i, this.$_.cloneDeep(obj));
      }
    },
    open_modify_color_popup(color_id) {
      this.is_modify_color_show = true;
      this.form_data_modify_color.color_id = color_id;
      this.form_data_modify_color.color_name = "";
    },
    close_modify_color_popup() {
      this.is_modify_color_show = false;
    },
    confirm_modify_color() {
      if (this.form_data_modify_color.color_name.length > 20) {
        this.$layer.msg(`No more than 20 characters`);
        return;
      }
      let idx = this.raw_color_list.findIndex(
        (v) => v.color_id === this.form_data_modify_color.color_id
      );
      if (idx > -1) {
        this.$set(this.raw_color_list, idx, {
          ...this.raw_color_list[idx],
          color_name: this.form_data_modify_color.color_name,
        });
      }
      let idx2 = this.custom_color.findIndex(
        (v) => v.color_id === this.form_data_modify_color.color_id
      );
      if (idx2 > -1) {
        this.$set(this.custom_color, idx2, {
          ...this.custom_color[idx2],
          color_name: this.form_data_modify_color.color_name,
          color_name_en: this.form_data_modify_color.color_name,
        });
      }
      this.is_modify_color_show = false;
    },
    open_choose_color_popup() {
      this.is_choose_color_popup_show = true;
      this.form_data_custom_color.id = 0;
      this.form_data_custom_color.color_alias = "";
    },
    close_choose_color_popup() {
      this.is_choose_color_popup_show = false;
    },
    add_custom_color() {
      if (this.form_data_custom_color.color_alias.length === 0) {
        this.$layer.msg(`Please fill in the custom name`);
        return;
      }
      if (this.form_data_custom_color.color_alias.length > 20) {
        this.$layer.msg(`No more than 20 characters`);
        return;
      }
      let uuid = util.uuid().toUpperCase();
      let obj = {
        color_id: uuid,
        color_key: uuid,
        color_name: this.form_data_custom_color.color_alias,
        color_name_en: this.form_data_custom_color.color_alias,
        color_value: "",
        type: 1,
      };
      this.custom_color.push(obj);
      this.temp_color_ids.push(obj.color_id);
      this.form_data_custom_color.id = 0;
      this.form_data_custom_color.color_alias = "";
    },
    del_custom_color(color_id) {
      let idx1 = this.custom_color.findIndex((v) => v.color_id === color_id);
      this.custom_color.splice(idx1, 1);
      this.choose_color(color_id);
    },
    remove_selected_color(color_id) {
      let idx1 = this.custom_color.findIndex((v) => v.color_id === color_id);
      if (idx1 > -1) {
        this.choose_color(color_id);
      }
      let idx2 = this.raw_color_list.findIndex((v) => v.color_id === color_id);
      if (idx2 > -1) {
        this.choose_color(color_id);
      }
    },
    toggle_size(size_key) {
      if (this.temp_size_ids.includes(size_key)) {
        this.temp_size_ids = this.temp_size_ids.filter((item) => {
          return item !== size_key;
        });
      } else {
        this.temp_size_ids.push(size_key);
        this.temp_size_ids = [...new Set(this.temp_size_ids)];
      }
    },
    confirm_choose_size_popup() {
      this.temp_size_ids.forEach((v) => {
        if (!this.select_size_ids.includes(v)) {
          this.choose_size(v);
        }
      });
      this.temp_size_ids = [];
      this.is_choose_size_popup_show = false;
    },
    choose_size(size_key) {
      if (this.select_size_ids.includes(size_key)) {
        this.select_size_ids = this.select_size_ids.filter((item) => {
          return item !== size_key;
        });
      } else {
        this.select_size_ids.push(size_key);
        this.select_size_ids = [...new Set(this.select_size_ids)];
      }
      let obj = this.table_data;
      if (this.$_.has(obj, size_key)) {
        delete obj[`${size_key}`];
        this.$set(this, "table_data", obj);
      } else {
        let temp_color = {};
        for (let ii in this.select_color_ids) {
          let color = this.available_color_list.find(
            (v) => v.color_id === this.select_color_ids[ii]
          );
          temp_color[this.select_color_ids[ii]] = { ...color, quantity: 0 };
        }
        let temp_complete = this.$_.cloneDeep(
          this.design?.pat?.size_info[size_key] || {}
        );
        if (this.design.pattern_type === 3) {
          // 定制版型情况
          temp_complete = this.$_.cloneDeep(
            this.design?.productcategory?.size_info[size_key] || {}
          );
        }
        for (let i in temp_complete) {
          if (!this.$_.has(temp_complete[i], "val")) {
            temp_complete[i].val = temp_complete[i].normal;
          }
        }
        this.$set(
          this.table_data,
          size_key,
          this.$_.cloneDeep({
            size: { size_key: size_key, size_alias: size_key },
            color: temp_color,
            complete: temp_complete,
            sort: this.raw_size_list.findIndex((v) => v === size_key),
            group_id: this.current_group_id
          })
        );
      }

      const map = new Map(
              Object.entries(this.table_data).sort(function (a, b) {
                if(a[1].group_id - b[1].group_id <= 0) {
                  return a[1].sort - b[1].sort;
                } else {
                  return false
                }
              })
      );
      this.$set(this, "table_data", Object.fromEntries(map));
    },
    open_choose_size_popup() {
      this.is_choose_size_popup_show = true;
    },
    close_choose_size_popup() {
      this.is_choose_size_popup_show = false;
    },
    open_modify_size_popup(size) {
      this.is_modify_size_show = true;
      this.form_data_custom_size.size_key = size;
      this.form_data_custom_size.size_alias = "";
    },
    close_modify_size_popup() {
      this.is_modify_size_show = false;
    },
    confirm_modify_size() {
      if (this.form_data_custom_size.size_alias.length > 10) {
        this.$layer.msg(`No more than 10 characters`);
        return;
      }
      this.$set(
        this.table_data[this.form_data_custom_size.size_key].size,
        "size_alias",
        this.form_data_custom_size.size_alias
      );
      this.is_modify_size_show = false;
    },
    remove_selected_size(size_key) {
      this.choose_size(size_key);
    },
    show_detail() {
      this.is_detail_show = true;
    },
    close_detail() {
      this.is_detail_show = false;
    },
    submit() {
      if (this.is_click) {
        return;
      }

      if (this.select_size_ids.length === 0) {
        this.$layer.msg(`Please select size`);
        return;
      }
      if (this.select_color_ids.length === 0) {
        this.$layer.msg(`Please select color`);
        return;
      }
      if (this.count < 1) {
        this.$layer.msg(
          `Please enter the quantity of customized clothing required`
        );
        return;
      }

      if (!this.new_style_no) {
        this.$DModal.confirm({
          content:
            "The style number will be automatically generated by the platform, do you agree?",
          okText: "Confirm",
          cancelText: "Cancel",
          onOK: async () => {
            this.confirm_submit();
          },
        });
      } else {
        this.confirm_submit();
      }
    },
    async confirm_submit() {
      const param = {};
      param.from = this.$route.query.from;
      param.new_style_no = this.new_style_no;
      param.form_data = this.table_data;
      param.color_list = this.available_color_list;
      param.uuid = this.$route.query.uuid;
      param.sample_extra = this.form_data_sample;
      this.is_click = true;
      CreateOrder(param)
        .then((response) => {
          this.$router.replace({
            name: "WorkBenchCheckout",
            query: { uuid: response.data.uuid },
          });
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          setTimeout(() => {
            this.is_click = false;
          }, 500);
        });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("showFooter", false);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none !important;
}

.container {
  background: #f6f7fa;
  padding: 30px 0 150px 0;

  .page {
    width: 1400px;
    margin: 20px auto;
    background: white;
    padding: 40px 50px;
    border-radius: 5px;
    overflow: hidden;
    .top-title {
      width: 100%;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 20px;
    }
    .cate-no-box {
      display: flex;
      align-items: center;
      column-gap: 20px;
      margin-top: 20px;
      .custom-no {
        display: flex;
        flex-direction: column;
        flex: 1;
        .label {
          font-weight: bold;
          color: #1a1a1a;
          font-size: 15px;
          &::before {
            content: "*";
            color: #fa3d5a;
          }
        }
        .input {
          width: 100%;
          height: 52px;
          line-height: 52px;
          border: 1px solid #dad5d1;
          border-radius: 5px;
          padding: 0 24px;
          outline: none;
        }
      }
      .other-items {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 100%;
        max-width: 300px;
        .label {
          font-weight: bold;
          color: #1a1a1a;
          font-size: 15px;
        }
        .input {
          width: 100%;
          max-width: 300px;
          height: 52px;
          line-height: 52px;
          border: 1px solid #dad5d1;
          border-radius: 5px;
          padding: 0 24px;
        }
      }
    }
    .label-title {
      color: #1a1a1a;
      font-weight: bold;
      font-size: 15px;
      margin-top: 25px;
      margin-bottom: 14px;
    }

    .big-title {
      color: #333333;
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: bold;
      // text-align: center;
    }

    .title {
      position: relative;
      color: #333333;
      border-left: 3px solid #fa3d5a;
      font-size: 16px;
      margin: 10px 0;
      padding-left: 8px;
      height: 15px;
      line-height: 15px;

      .tip {
        font-size: 12px;
        color: #4d4d4d;
      }

      .btn-add {
        position: absolute;
        top: 5px;
        right: 0;
        color: #4d4d4d;
        font-size: 13px;
      }
    }

    .spec-list {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      column-gap: 10px;
      border: 1px solid #dad5d1;
      border-radius: 5px;
      .item-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex: 1;
        .spec-item {
          position: relative;
          margin: 10px;
          padding-right: 20px;
          padding-left: 10px;
          //   width: 100px;
          height: 38px;
          background: #f5f5f5;
          text-align: center;
          font-size: 14px;
          color: #1a1a1a;
          border-radius: 5px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          img {
            width: 26px;
            height: 26px;
            &.icon-del {
              position: absolute;
              top: 3px;
              right: 3px;
              width: 16px;
              height: 16px;
              z-index: 100;
            }
          }
        }
      }
      .add-btn {
        // width:70px;
        margin-right: 20px;
        background: #fbe8eb;
        border-radius: 14px;
        color: #fa3d5a;
        font-size: 12px;
        padding: 8px 12px;
        flex-shrink: 0;
        cursor: pointer;
      }
    }

    .style-no {
      padding: 0 20px;
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #dad5d1;
      border-radius: 5px;
      outline: none;
      flex: 1;
    }

    .report {
      border: 1px solid #808080;

      .cell {
        padding: 11px 20px;
        /*border-top: 1px solid #808080;*/
        border-bottom: 1px solid #808080;
        font-size: 14px;
      }

      .border-top {
        border-top: 1px solid #808080;
      }

      .border-right {
        border-right: 1px solid #808080;
      }

      .border-right-no {
        border-right: none !important;
      }

      .border-bottom-no {
        border-bottom: none !important;
      }

      .row {
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        overflow: hidden;

        .cell {
          color: #666;

          span {
            font-weight: bold;
            color: #333;
          }
        }
      }

      .wrap {
        display: flex;
        flex-wrap: nowrap;

        .left {
          // width: 920px;
          width: 100%;
          // border-right: 1px solid #808080;

          .kuanshitu {
            .image-list {
              padding: 16px 0;
              display: flex;
              flex-wrap: wrap;

              .image-item {
                width: 180px;
                height: 180px;
                margin: 10px 5px;
                border: 1px solid #ebebeb;
                object-fit: contain;
              }
            }
          }

          .gongyishuoming {
            .left {
              width: 260px;
              height: 305px;
              object-fit: contain;
            }

            .right {
              padding: 10px 20px;
            }
          }

          .mianliao-cell {
            width: 100%;

            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              table-layout: fixed;
              border: 1px solid #e5e5e5;
            }

            tr {
              border-bottom: 1px solid #e5e5e5;
            }

            th:first-child,
            td:first-child {
              width: 75px;
            }

            th:nth-child(2),
            td:nth-child(2) {
              width: 240px !important;
              text-align: center;
              overflow: hidden;

              .table-info {
                display: flex;
                align-items: center;
                column-gap: 3px;
                width: 100%;
                font-size: 12px;

                .fa-img {
                  width: 60px;
                  height: 60px;
                  object-fit: contain;
                }

                .text {
                  display: flex;
                  align-content: space-around;
                  align-items: center;
                  flex-wrap: wrap;

                  .fa-name {
                    width: 100%;
                    font-weight: bold;
                    text-align: left;
                    line-height: 1.5;
                    white-space: pre-line;
                  }

                  .fa-key {
                    width: 100%;
                    line-height: 1.5;
                    text-align: left;
                  }
                }
              }
            }
            td:nth-child(3),
            th:nth-child(3) {
              width: 120px;
            }
            td:nth-child(4),
            td:nth-child(5),
            th:nth-child(4),
            th:nth-child(5) {
              width: 150px;
            }
            td:nth-child(6),
            th:nth-child(6) {
              width: 200px;
            }

            td:nth-child(7),
            th:nth-child(7) {
              width: 130px;
            }

            th,
            td {
              // border: 1px solid #ddd;
              padding: 8px;
              width: auto;
              min-width: 150px;
              max-width: none;
              text-align: center;

              .colors {
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 3px;

                .color-image {
                  width: 40px;
                  height: 40px;
                }

                .color-name {
                  font-size: 12px;
                }
              }
            }
          }

          .fuliao-cell {
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              table-layout: fixed;
              border: 1px solid #e5e5e5;
            }

            tr {
              border-bottom: 1px solid #e5e5e5;
            }

            th:first-child,
            td:first-child {
              width: 75px;
            }

            th:nth-child(2) {
              text-align: center !important;
            }

            th:nth-child(2),
            td:nth-child(2) {
              width: 330px;
              text-align: left;
              overflow: hidden;

              .product-info {
                display: flex;
                align-items: center;
                column-gap: 3px;
                width: 100%;
                font-size: 12px;

                .fa-img {
                  width: 60px;
                  height: 60px;
                  object-fit: contain;
                }

                .text {
                  display: flex;
                  align-content: space-around;
                  align-items: center;
                  flex-wrap: wrap;

                  .fa-name {
                    width: 100%;
                    font-weight: bold;
                    text-align: left;
                    line-height: 1.5;
                  }

                  .fa-key {
                    width: 100%;
                    line-height: 1.5;
                  }
                }
              }
            }

            td:nth-child(3),
            th:nth-child(3) {
              width: 120px;
            }

            td:nth-child(4),
            th:nth-child(4),
            td:nth-child(5),
            th:nth-child(5) {
              width: 150px;
            }

            td:nth-child(6),
            th:nth-child(6) {
              width: 200px;
            }

            th,
            td {
              // border: 1px solid #ddd;
              padding: 8px;
              width: auto;
              min-width: 150px;
              max-width: none;
              text-align: center;

              .fuliao-colors {
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 3px;

                .fuliao-color {
                  width: 40px;
                  height: 40px;
                }

                .fuliao-color-name {
                  font-size: 12px;
                }
              }
            }
          }
        }

        .right {
          width: 380px;

          .file-item {
            display: block;
            margin: 10px 0;
          }

          .c-item {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: left;
            margin: 10px 0;

            img {
              width: 45px;
              height: 45px;
              margin-right: 20px;
              object-fit: contain;
            }

            span {
            }

            p {
              width: 100%;
              margin-top: 10px;
              padding: 10px;
              background: #fafafa;
              border-radius: 5px;
            }
          }
        }
      }
    }

    .other-file-cell {
      .file-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;

        .file-item {
          width: 330px;
          height: 42px;
          line-height: 42px;
          background: #fafafa;
          padding: 0 10px;
          margin: 5px 10px;
        }
      }
    }
  }

  .table {
    width: 100%;
    table-layout: fixed;
    text-align: center;
    border-collapse: collapse;
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    border-right: 1px solid #e2e5e9;
    box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.1);

    th,
    td {
      box-sizing: border-box;
    }

    th:first-child,
    td:first-child {
      position: sticky;
      left: 0;
      z-index: 10;
      background: #f8f8f9;
    }

    .size {
      width: 160px;
    }
    .color {
      width: 130px;
    }

    .complete {
      width: 130px;
    }
    .input {
      text-align: center;
      outline: none;
      border: 1px solid #e2e5e9;
      width: 100%;
    }

    th {
      padding: 0 5px;
      height: 50px;
      line-height: 50px;
      background: #f8f8f9;
      border: 1px solid #e2e5e9;

      &.color {
        color: #fa3d5a;
      }
      .icon-edit {
        width: 12px;
        height: 12px;
        margin: 0 10px;
      }
    }

    td {
      padding: 2px 5px;
      height: 50px;
      line-height: 50px;
      border: 1px solid #e2e5e9;
      font-size: 15px;
      .icon-edit {
        width: 12px;
        height: 12px;
        margin: 0 10px;
      }
    }
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: white;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    z-index: 10;
    .footer-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .price-btns {
        display: flex;
        align-items: center;
        .price-wrap {
          color: #333333;
          font-size: 16px;
          position: relative;

          .shu {
            margin: 0 10px;
          }

          .money1 {
            color: #fa3d5a;
          }

          .money2 {
            color: #fa3d5a;
            font-weight: bold;
            font-size: 20px;
          }

          .btn-detail {
            color: #808080;
            margin: 0 35px;
            font-size: 14px;
            cursor: pointer;
          }

          .detail-modal {
            background: white;
            box-shadow: 0px 0px 20px 0px #a6a6a6;
            z-index: 100;
            position: absolute;
            bottom: 40px;
            right: 0;
            background: white;
            border-radius: 10px;
            padding: 15px;
            width: 240px;

            .p-list {
              .p-item {
                display: flex;
                justify-content: space-around;
                font-size: 14px;
                margin: 10px 0;

                .left {
                  font-weight: bold;
                  width: 50%;
                }

                .right {
                  text-align: right;
                  width: 50%;
                  color: #fa3d5a;
                  font-weight: bold;
                }
              }
            }
          }
        }

        .btn {
          height: 38px;
          line-height: 38px;
          border-radius: 19px;
          font-size: 14px;
          padding: 0 20px;
          cursor: pointer;

          &.btn-confirm {
            width: 200px;
            background: #fa3d5a;
            color: white;
            text-align: center;
          }

          &.btn-back {
            // width: 120px;
            margin-right: 20px;
            background: #ebebeb;
            color: #1c1f23;
            text-align: center;
          }
        }
      }
      .footer-tips {
        width: 100%;
        text-align: center;
        font-size: 12px;
        margin-top: 10px;
        color: red;
        // font-weight:bold;
      }
    }
  }

  .popup {
    padding: 20px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      text-align: center;
    }

    .color-list {
      height: 420px;
      overflow-y: scroll;
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      align-content: flex-start;
      .color-item {
        position: relative;
        margin: 5px 10px;
        //padding-right: 10px;
        padding: 0 10px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        background: #f5f5f5;
        // width: 90px;
        height: 38px;
        border-radius: 5px;
        img {
          width: 26px;
          height: 26px;
          &.icon-del {
            position: absolute;
            top: 3px;
            right: 3px;
            width: 16px;
            height: 16px;
            z-index: 100;
          }
        }
        &.active {
          border: 1px solid #fa3d5a;
        }
      }
    }

    .group-list {
      margin: 10px 0;;
      width: 200px;
      height: 40px;
      line-height: 40px;
      padding:5px 10px;
    }
    .size-list {
      height: auto;
    }

    .form-group {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      .label {
        background: #e2e5e9;
        width: 140px;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
      }
      .input {
        width: 320px;
        height: 51px;
        line-height: 51px;
        outline: none;
        border: 1px solid #e2e5e9;
        padding: 0 20px;
      }
      .btn-add {
        margin-left: -96px;
        width: 88px;
        height: 36px;
        line-height: 36px;
        color: white;
        background: #fa3d5a;
        border-radius: 18px;
        text-align: center;
      }
    }

    .tip {
      color: #808080;
      span {
        color: #fa3d5a;
      }
    }

    .btn-modify {
      margin: 20px auto;
      width: 150px;
      height: 38px;
      line-height: 38px;
      color: white;
      font-size: 14px;
      background: #000000;
      border-radius: 5px;
      text-align: center;
    }
  }
}
</style>
